import { __styles, mergeClasses, shorthands, tokens, typographyStyles } from '@fluentui/react-components';
export const timestampClassNames = {
  root: 'fai-Timestamp'
};
/**
 * Styles for the root slot
 */
const useStyles = __styles({
  root: {
    sj55zd: "fxc4j92",
    mc9l5x: "f1w7gpdv",
    fsow6f: "f17mccla",
    Bahqtrf: "fk6fouc",
    Be2twd7: "fy9rknc",
    Bhrd7zp: "figsok6",
    Bg96gwp: "fwrc4pm",
    B6of3ja: "f1hu3pq6",
    t21cq0: ["f11qmguv", "f1tyq0we"],
    jrapky: "f19f4twv",
    Frg6f3: ["f1tyq0we", "f11qmguv"]
  }
}, {
  d: [".fxc4j92{color:var(--colorNeutralForeground4);}", ".f1w7gpdv{display:inline;}", ".f17mccla{text-align:center;}", ".fk6fouc{font-family:var(--fontFamilyBase);}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".fwrc4pm{line-height:var(--lineHeightBase200);}", ".f1hu3pq6{margin-top:0;}", ".f11qmguv{margin-right:0;}", ".f1tyq0we{margin-left:0;}", ".f19f4twv{margin-bottom:0;}"]
});
/**
 * Apply styling to the Timestamp slots based on the state
 */
export const useTimestampStyles_unstable = state => {
  const styles = useStyles();
  state.root.className = mergeClasses(timestampClassNames.root, styles.root, state.root.className);
  return state;
};
//# sourceMappingURL=useTimestampStyles.js.map